/*
 * Application Insights JavaScript SDK - Core, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


export var strIKey = "iKey";
export var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map